<div *ngIf="!this.loading" class="expand-group" >
  <div class="card card-secondary">
    <gb-expander 
        class="gb-expander" 
        *ngFor="let item of collection;  trackBy: trackByCmsTitle"
        [trackLink]="item.trackLink"
        [prop10]="item.trackProp">
      <div class="gb-expander-btn" role="button" aria-expanded="false" tabindex="0">
        <div *ngIf="item.cmsTitle">{{item.cmsTitle | translate}}</div>
      </div>
      <div class="gb-expander-content">
        <div class="gb-expander-content-body p-4 gb-body4">
          <span *ngIf="item.condition === undefined && item.cmsContent" [innerHTML]="item.cmsContent | translate"></span>
          <span *ngIf="item.condition === true && item.cmsContentTrue" [innerHTML]="item.cmsContentTrue | translate"></span>
          <span *ngIf="item.condition === false && item.cmsContentFalse" [innerHTML]="item.cmsContentFalse | translate"></span>
        </div>
      </div>
    </gb-expander>
  </div>
</div>
